<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/components/ui/input-otp'

const props = defineProps({
    modelValue: {
        type: String,
        required: true
    },
})

const emit = defineEmits(['update:modelValue'])

const model = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

const attributes = useAttrs()
</script>

<template>
  <!-- <div class="space-y-2"> -->
    <InputOTP
      v-model="model"
      v-bind="attributes"
      class="w-full max-w-xs"
    >
      <InputOTPGroup class="flex justify-between items-center w-full">
        <InputOTPSlot :index="0" class="text-text-soft bg-white h-16 w-16 border border-gray-300 rounded-lg focus:ring-[#41AE49] focus:border-[#41AE49]" />
        <InputOTPSlot :index="1" class="text-text-soft bg-white h-16 w-16 border border-gray-300 rounded-lg focus:ring-[#41AE49] focus:border-[#41AE49]" />
        <InputOTPSlot :index="2" class="text-text-soft bg-white h-16 w-16 border border-gray-300 rounded-lg focus:ring-[#41AE49] focus:border-[#41AE49]" />
        <InputOTPSlot :index="3" class="text-text-soft bg-white h-16 w-16 border border-gray-300 rounded-lg focus:ring-[#41AE49] focus:border-[#41AE49]" />
      </InputOTPGroup>
    </InputOTP>
  <!-- </div> -->
</template>
